module.exports = __webpack_public_path__ + "img/van.06a7f990.png";